import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

// Load app config (mirrored from original app.js)
async function fetchAppConfig() {
  try {
    const response = await fetch('/api/get_config.php')
    const contentType = response.headers.get('content-type')
    if (!response.ok || !contentType || !contentType.includes('application/json')) {
      throw new Error('Invalid config response')
    }
    const config = await response.json()
    window.APP_CONFIG = config
    console.log('App configuration loaded:', config)
  } catch (error) {
    console.error('Error fetching app configuration:', error)
    window.APP_CONFIG = { platformFeePercentage: 0.06, platformAdminUserId: 35 }
  }
}
fetchAppConfig()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter basename="/app">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
